<template>
  <div class="right-tag">
    <ul class="right-ul">
      <li class="dowmApp li-1" @click="showDialog = true">
        <div class="icon-text">
          <img src="../../assets/image/rightNav/right001.png" alt="立即体验">
          <span class="dw-p p-1">立即体验</span>
        </div>
      </li>

      <li class="dowmApp li-2" @click="showDialog = true">
        <div class="icon-text">
          <img src="../../assets/image/rightNav/right002.png" alt="电话质询">
          <span class="dw-p p-1">电话质询</span>
        </div>
      </li>

      <li class="dowmApp li-3" @click="showDialog = true">
        <div class="icon-text">
          <img src="../../assets/image/rightNav/right003.png" alt="在线质询">
          <span class="dw-p p-1">在线质询</span>
        </div>
      </li>

      <li class="dowmApp li-4" @click="goTop">
        <div class="icon-text">
          <img src="../../assets/image/rightNav/right004.png" alt="返回顶部">
          <span class="dw-p p-1">返回顶部</span>
        </div>
      </li>
      <!-- 引入弹窗组件 -->
      <call-me-dialog v-if="showDialog" :visible.sync="showDialog" />
    </ul>

  </div>
</template>
<style>
  @import './right.css';
  @import '../css/common.css';
</style>
<script>

  import CallMeDialog from "../CallMeDialog.vue";

  export default {
    name: 'right',
    components: {CallMeDialog},
    data() {
      return {
        showDialog: false
      }
    },
    methods: {
      // 回到顶部
      goTop(){
        // chrome
        document.body.scrollTop = 0
        // firefox
        document.documentElement.scrollTop = 0
        // safari
        window.pageYOffset = 0
      }
    }
    ,
    created: function () {
    }
  }
</script>
<Style>
body, div {
  margin: 0;
  padding: 0;
}

ul, li {
  margin: 0;
  padding: 0;
  list-style: none;
  cursor: pointer;
}

.right-tag {
  position: fixed;
  right: 0;
  z-index: 99999999;
  top: 35%;
  background: #0788dc;
}

.right-tag-qrcode {
  position: fixed;
  right: 0;
  z-index: 99999999;
  top: 35%;
  background: #FFFFFF;
  margin-right: 72px;
  width: 175px;
  height: 218px;
  border: 1px solid #C0C0C0;
  display: none;
}

.phone{
  top: 53.5%;
  height: 92px;
}

.right-ul li {
  width: 22px;
  height: 47px;
  border: 1px solid #C0C0C0;
  border-bottom: 0px;
  padding: 20px;
}

.right-ul .bt {
  border-bottom: 1px solid #C0C0C0;
}

/*-@代表 src 不这样写会报错*/
.li-1:hover .rd-1 {
  background: url("~@/assets/image/rightNav/right2.png");
}
.li-1:hover .right-tag-qrcode {
  display: block;
}

.li-2:hover .rd-2 {
  background: url("~@/assets/image/rightNav/right4.png");
}

.li-3:hover .rd-3 {
  background: url("~@/assets/image/rightNav/right6.png");
}
.li-3:hover .phone {
  display: block;
}

.li-4:hover .rd-4 {
  background: url("~@/assets/image/rightNav/right8.png");
}

.li-1:hover .p-1 {
  color: #5a9066;
}
.li-2:hover .p-2{
  color: #5a9066;
}
.li-2:hover .p-22 {
  color: #5a9066;
}

.li-3:hover .p-3 {
  color: #5a9066;
}
.li-4:hover .p-4 {
  color: #5a9066;
}

.rd-1 {
  background: url("~@/assets/image/rightNav/right001.png");
  margin-top: -7px;
  margin-left: 3px;
  height: 23px;
  width: 16px;
}

.dowmApp .rd-2 {
  height: 15px;
  width: 17px;
  margin-top: -7px;
  margin-left: 3px;
  background: url("~@/assets/image/rightNav/right3.png");
}

.dowmApp .rd-3 {
  height: 19px;
  width: 17px;
  margin-top: -7px;
  margin-left: 3px;
  background: url("~@/assets/image/rightNav/right5.png");
}

.dowmApp .rd-4 {
  height: 10px;
  width: 17px;
  margin-top: -7px;
  margin-left: 3px;
  background: url("~@/assets/image/rightNav/right7.png");
}

.dw-p {
  margin-top: 2px;
  width: 26px;
  line-height: 1.5;
  font-size: 12px;
  margin-left: 0px;
  color: #9c9696;
}

.p-2{
  margin-top: 12px;
  line-height: 0;
  width: 36px;
  margin-left: 1px;
}

.p-22{
  line-height: 1;
  margin-top: 8px;
  width: 37px;
  margin-left: -5px;
}

.qrcode{
  width: 150px;
  height: 150px;
  margin-left: 12.5px;
  margin-top: 12.5px;
}

.right-tag-qrcode p{
  color: #9c9696;
  font-size: 12px;
  text-align: center;
  width: 150px;
  margin-left: 12.5px;
  line-height: 0;
}
.right-tag-qrcode .qr-p{
  line-height: 1;
  margin-top: 5px;
}

.right-tag-qrcode .mt{
  margin-top: 30px;
}

.right-ul .li-1{
  border-top-left-radius: 10px;
  border-top-right-radius: 3px;
}

.right-ul .li-4{
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.right-tag-qrcode p{
  margin: 16px 12.5px;
}

</Style>



// WEBPACK FOOTER //
// src/components/right/right.vue